

import {Component, Prop} from "vue-property-decorator";
import {IMaterial, MaterialType} from "shared/entities/material";
import * as icons from "@fortawesome/free-solid-svg-icons";
import {orderBy} from "lodash";
import {Api} from "shared/api";
import AuthMixin from "@/mixins/auth.mixin";
import {apiHandler} from "@/services/api-handler";

@Component({})
export default class TrainingSection extends AuthMixin {
    @Prop({default: false})
    v2!: boolean;

    icons = icons;
    MaterialType = MaterialType;
    materials: IMaterial[] = []
    completed: Record<string, boolean> = {};

    async mounted() {
        this.materials = await apiHandler(() => Api.material.Get());
        this.completed = await apiHandler(() => Api.material.completed.Get());
    }

    get categories(): string[] {
        // Trim so a stray leading/trailing space in the category name does not
        // create a second, near-identical group.
        return orderBy(Array.from(new Set(this.materials.map(m => m.category.trim()))));
    }

    get orderedMaterials(): Record<string,IMaterial[]> {
        const ordered: Record<string, IMaterial[]> = {};
        for (const material of this.materials) {
            const category = material.category.trim();
            if (!ordered[category]) {
                ordered[category] = [];
            }
            ordered[category].push(material);
        }
        for (const category of Object.keys(ordered)) {
            ordered[category] = orderBy(ordered[category], ["order"]);
        }
        return ordered;
    }

    completedCount(category: string): number {
        return (this.orderedMaterials[category] || [])
            .filter(m => this.completed[m.id]).length;
    }

    iconClass(material: IMaterial) {
        if (this.completed[material.id]) return "text-success";
        return "text-primary";
    }

    // v2 keeps the type icon and shows completion as a separate badge.
    iconType(material: IMaterial) {
        if (material.type === MaterialType.Video) return "faPlayCircle";
        return "faBookOpen";
    }

    // v1 swaps the icon out for a checkmark, as it always did.
    legacyIconType(material: IMaterial) {
        if (this.completed[material.id]) return "faCheckCircle";
        return "faBookOpen";
    }

    gotoTraining(id: string) {
        this.$router.push(`/material/${id}`);
    }
}

